<div class="header">
  <img src="/assets/logo.svg" />
  <span class="fill"></span>
  <adkom-login></adkom-login>
</div>

<p class="blue-header">We’ve built the biggest and most advanced network of independent OOH inventory.</p>
